
namespace RioERP.Orders {
    export class OrderBrandAmbassadorShareColumns {
        static columnsKey = 'Orders.OrderBrandAmbassadorShare';
    }
}